import React, { useState, useCallback } from "react";
import firebase from "../firebaseConfig";
import M from "materialize-css/dist/js/materialize.min.js";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Background from "./yepbcg.webp";
import LogoImage from "./YEP new Logo.png";

// const Login = (props) => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   let navigate = useNavigate();

//   const login = async (e) => {
//     e.preventDefault();
//     try {
//       if (["admin@gmail.com", "info@yep.education"].includes(email)) {
//         M.toast({ html: `Invalid Credentials`, classes: "red rounded" });
//       } else {
//         const user = await firebase
//           .auth()
//           .signInWithEmailAndPassword(email, password);
//         if (user) {
//           M.toast({
//             html: `Login Successfully`,
//             classes: "green darken-1 rounded",
//           });
//           navigate("/HomePage");
//         }
//       }
//     } catch (error) {
//       M.toast({ html: `Invalid Credentials`, classes: "red rounded" });
//     }
//   };
//   return (
//     <div className="row">
//       <div className="col s12 m6 offset-m3">
//         <div className="card hoverable">
//           <div className="card-content">
//             <h5 className="center">Login to Dashboard</h5>
//             <form onSubmit={login}>
//               <div className="row">
//                 <div className="input-field col s12 m8 offset-m2">
//                   <i className="material-icons prefix">email</i>
//                   <input
//                     id="email"
//                     type="email"
//                     className="validate"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                   />
//                   <label htmlFor="email">Email</label>
//                 </div>
//                 <div className="input-field col s12 m8 offset-m2">
//                   <i className="material-icons prefix">keyboard_hide</i>
//                   <input
//                     id="password"
//                     type="password"
//                     className="validate"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                   <label htmlFor="password">Password</label>
//                 </div>
//               </div>
//               <div className="card-action center">
//                 <button
//                   className="waves-effect waves-light btn"
//                   style={{ margin: "18px" }}
//                   type="submit"
//                 >
//                   Login
//                   <i className="material-icons right">add_circle_outline</i>
//                 </button>
//                 <button
//                   className="waves-effect waves-light btn red"
//                   type="reset"
//                   onClick={() => {
//                     setEmail("");
//                     setPassword("");
//                   }}
//                 >
//                   Reset <i className="material-icons right">cancel</i>
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;



const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const login = useCallback(async (e) => {
    e.preventDefault();
    if (!email || !password) {
      M.toast({
        html: "Please enter both email and password",
        classes: "red rounded",
      });
      return;
    }
    setLoading(true);
    try {
      if (["admin@gmail.com", "info@yep.education"].includes(email)) {
        M.toast({ html: `Invalid Credentials`, classes: "red rounded" });
      } else {
        const user = await firebase
          .auth()
          .signInWithEmailAndPassword(email, password);
        if (user) {
          M.toast({
            html: `Login Successfully`,
            classes: "green darken-1 rounded",
          });
          navigate("/HomePage");
        }
      }
    } catch (error) {
      M.toast({ html: `Invalid Credentials`, classes: "red rounded" });
    } finally {
      setLoading(false);
    }
  }, [email, password, navigate]);

  const handleReset = useCallback(() => {
    setEmail("");
    setPassword("");
  }, []);

  const handleClickShowPassword = useCallback(() => setShowPassword((show) => !show), []);

  const handleMouseDownPassword = useCallback((event) => {
    event.preventDefault();
  }, []);


  return (
    <Grid
      container
      component="main"
      sx={{
        // Use minHeight and calc() to dynamically fill space between header and footer
        // height: "100vh",
        minHeight: "calc(100vh - 94px)", // Approx. NavBar (70px) + Footer (42px)
        marginTop: "-15px",
        overflow: "auto", // Use auto overflow to prevent cutting content
        // flexGrow:1,
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)", // Center the full-width element to remove horizontal space
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${Background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Grid
        item
        xs={11}
        sm={10}
        md={8}
        lg={7}
        component={Card}
        elevation={6}
        sx={{
          // Glassmorphism styles applied to the Card itself
          borderRadius: 4,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(5px)",
          boxShadow: "0px 10px 30px -5px rgba(0,0,0,0.3)",
          overflow: "hidden", // Ensure child grids are contained
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={5}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 3,
              backgroundColor: "action.hover",
              borderRight: { sm: "1px solid" },
              borderColor: { sm: "divider" },
            }}
          >
            <img
              src={LogoImage}
              style={{ width: "80%", maxWidth: "232px" }}
              alt="YEP Logo"
              loading="lazy"
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <Box
              sx={{
                p: 4,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Typography
                component="h1"
                variant="h5"
                sx={{ mb: 2, textAlign: "center" }}
              >
                Login to Dashboard
              </Typography>
              <Box component="form" noValidate onSubmit={login} sx={{ mt: 1 }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  // type="password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Box sx={{ mt: 3, mb: 2, position: "relative" }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ py: 1.5 }}
                    disabled={loading}
                  >
                    Login
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: "primary.main",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Box>
                <Button
                  type="reset"
                  fullWidth
                  variant="outlined"
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default React.memo(Login);
